import {SketchRelationDefinition} from './SketchRelationDefinition';
import type {ISketchObject} from '../../../../mesh/sketch/ISketchObject';


/**
 * 多目标约束抽象基类。
 * 职责：
 * 1. 关系实例维护多个公式目标；
 * 2. 支持由各目标对象的关系容器追加绑定。
 */
export function isMultiTargetRelation(value: object): value is MultiTargetRelation<any> {
    return Reflect.get(value, "isMultiTargetRelation") === true;
}

export abstract class MultiTargetRelation<T extends ISketchObject> extends SketchRelationDefinition<T> {
    readonly isMultiTargetRelation: boolean = true;
}


